import { createContext, useContext } from "react";
import type { SubjectConfig } from "@shikaku/shared";

export const SubjectConfigContext = createContext<SubjectConfig | null>(null);

export function useSubjectConfig(): SubjectConfig {
  const ctx = useContext(SubjectConfigContext);
  if (!ctx) throw new Error("SubjectConfigContext not provided");
  return ctx;
}
